// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__gY3U6","errors":"Errors_errors__3psYs"};